/**
 * Modal scroll lock — global singleton registry
 *
 * Prevents background scroll when any modal is open by:
 *   1. Saving current scroll position
 *   2. Setting overflow:hidden + position:fixed on body (anchors it, removes scroll)
 *   3. Restoring scroll position on unlock (no jump)
 *
 * The touch-event guard blocks swipe/numeric-scroll gestures that bypass
 * overflow:hidden on some mobile browsers (iOS Safari, Chrome Android).
 */

let registeredCount = 0;
let savedScrollY = 0;

const guardTouchMove = (e: TouchEvent) => {
  // Allow scrolling inside modal content, block everything else
  const path = e.composedPath() as Element[];
  const isInsideModal = path.some(el => el.classList?.contains('modal-scroll-lock'));
  if (!isInsideModal) {
    e.preventDefault();
  }
};

const applyScrollLock = () => {
  savedScrollY = window.scrollY;
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
  document.body.style.top = `-${savedScrollY}px`;
  document.body.style.height = '100vh';
  document.addEventListener('touchmove', guardTouchMove, { passive: false });
};

const removeScrollLock = () => {
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.width = '';
  document.body.style.top = '';
  document.body.style.height = '';
  document.removeEventListener('touchmove', guardTouchMove);
  window.scrollTo(0, savedScrollY);
};

export const modalScrollLock = {
  lock: () => {
    registeredCount++;
    if (registeredCount === 1) {
      applyScrollLock();
    }
  },

  register: () => modalScrollLock.lock(),

  unlock: () => {
    if (registeredCount <= 0) return;
    registeredCount--;
    if (registeredCount === 0) {
      removeScrollLock();
    }
  },

  unregister: () => modalScrollLock.unlock(),

  reset: () => {
    registeredCount = 0;
    document.removeEventListener('touchmove', guardTouchMove);
    removeScrollLock();
  },
};

export const scrollLock = modalScrollLock;
